import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=42c21276&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42c21276')) {
      api.createRecord('42c21276', component.options)
    } else {
      api.reload('42c21276', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=42c21276&", function () {
      api.rerender('42c21276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R6z7Pyy3zMgI/JS/comp/childrenage.vue"
export default component.exports